export default {"src":"/_next/static/media/AwsLogo.33de308b.svg","height":182,"width":304};